import { DialogConfig, DialogRef, DialogRole } from '@angular/cdk/dialog';
import { ComponentType } from '@angular/cdk/portal';
import { Component, EventEmitter, Injectable, OnDestroy, Output } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { PopupItem } from 'src/app/common/services/popup/popup-item';
import { ProductSelectionControlComponent } from 'src/app/foundation/product-selection-control/product-selection-control.component';
import { RemarksControlComponent } from 'src/app/foundation/remarks-control/remarks-control.component';
import { COBProductSelectionFormComponent } from 'src/app/rcob/cob-product-selection-form/cob-product-selection-form.component';
import { AlertDialogComponent } from '../../dialogs/alert-dialog/alert-dialog.component';
import { ConfirmationDialogComponent } from '../../dialogs/confirmation-dialog/confirmation-dialog.component';
import { ResultPageComponent } from 'src/app/process-shell/result-page/result-page.component';
import { FilePreviewComponent } from 'src/app/rcob/file-preview/file-preview.component';
import { ServiceRequestInfoComponent } from 'src/app/service-request/service-request-info/service-request-info.component';
import { AccChequeBookRequestFormComponent } from 'src/app/casa-accounts/acc-cheque-book-request-form/acc-cheque-book-request-form.component';
import { ProfilePicResultFormComponent } from 'src/app/common/components/profile-pic-result-form/profile-pic-result-form.component';
import { TransfersResultPageComponent } from 'src/app/process-shell/transfers-result-page/transfers-result-page.component';
import { SettingsResultPageComponent } from 'src/app/process-shell/settings-result-page/settings-result-page.component';
import { OnlineOfflineDialogComponent } from '../../dialogs/online-offline-dialog/online-offline-dialog.component';
import { ProfilePicResultPageComponent } from 'src/app/process-shell/profile-pic-result-page/profile-pic-result-page.component';

@Injectable({
  providedIn: 'root',
})
export class DialogService {

  defaultDialogData: CBXDialogData = {
    title: 'Done',
    message: 'Successfully completed',
    button: ['Close']
  }

  defaultDialogOptions: CBXDialogOptions = {
      component: 'alert',
      data: this.defaultDialogData,
      width: '100%',
      hasBackdrop: true,
      panelClass: 'alert-dialog',
      backdropClass: 'alert-dialog-backdrop',
      disableClose: false
  }
  readonly afterAllClosed: Observable<void>;

  constructor(private _dialog: MatDialog) {}

  open(dialogOptions: CBXDialogOptions){
    this._dialog.open(this.getComponent(dialogOptions.component), {
    ... this.defaultDialogOptions,
    ... dialogOptions
    }).afterClosed().subscribe(
      (action)=> {
        if (action) return dialogOptions.closeFn(action);
        else return dialogOptions.closeFn();
      }
    );
    // return this.cBXMatDialogRef
  }

  getComponent(path): ComponentType<any> {
    let component: ComponentType<any>;
    switch (path) {
      case 'alert': component = AlertDialogComponent; break;
      case 'confirmation': component = ConfirmationDialogComponent; break;
      case 'result': component = ResultPageComponent; break;
      case 'filePreview': component = FilePreviewComponent; break;
      case 'sr-stages': component = ServiceRequestInfoComponent; break;
      case 'CHQBKREQ': component = AccChequeBookRequestFormComponent; break;
      case 'profilepic-result': component = ProfilePicResultFormComponent; break;
      case 'transfers-result-info': component = TransfersResultPageComponent; break;
      case 'settings-result-info': component = SettingsResultPageComponent; break;
      case 'show-online-offline': component = OnlineOfflineDialogComponent; break;
      case 'profile-pic-result-page': component = ProfilePicResultPageComponent; break;
      
    }
    return component;
  }

  getPopup(path) {
    let children: PopupItem;
    switch (path) {
      case 'CHQBKREQ':
        children = new PopupItem(AccChequeBookRequestFormComponent, {});
        break;
    }

    return children;
  }


}

export class CBXDialogOptions extends MatDialogConfig {
  result?: 'success' | 'failure' | 'warning';
  component?: string = 'alert | confirmation';
  data?: CBXDialogData;
  closeFn?: any;
  title?: string;
}

export class CBXDialogData {
  title?: string;
  message?: string;
  refNum?: string;
  button?: any[];
  files?: File[];
  data?: any;
  currentStage?:string;
  backNavPath?:string;
  result?:string;
}
// @Component({
//   template: ''
// })
// export class CBXMatDialogRef {
//   constructor() {}
//   // @Output() close: EventEmitter<any>;
//   @Output("close") close: EventEmitter<boolean> = new EventEmitter<boolean>();

//   afterClosed() {
//     // this.close = new EventEmitter();
//     return this.close;
//   }

// }
